import styled from "@emotion/styled/macro";
import isStyledPropsValid from "utils/isStyledPropsValid";

const black = "#222";

const buttonMixin = ({
  theme,
  width,
  height,
  background,
  textHeight,
  textWidth,
  textColor,
  border,
}) => ({
  ...(background && {
    background: background,
  }),
  width: width,
  height: height,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "2px",
  ...(border && {
    border: `1px solid ${border}`,
  }),

  "&:after": {
    content: '""',
    width: textWidth,
    height: textHeight,
    borderRadius: "5px",
    background: textColor,
  },
});

const borderMixin = (color) => {
  return `1px solid ${color}`;
};

export const StyledDemoTemplateContainer = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, bgColor }) => ({
  backgroundColor: bgColor,
}));
export const StyledDemoTemplate = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, bgColor }) => ({
  padding: "30px 24px",
  margin: "0 auto",
  maxWidth: 275,
}));
export const StyledHeaderContainer = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  marginBottom: "16px",
  textAlign: "center",
}));
export const StyledHeaderTitle = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, color }) => ({
  fontSize: "16px",
  fontWeight: 600,
  marginBottom: "5.54px",
  color: color,
}));
export const StyledHeaderContent = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, color }) => ({
  fontSize: "7px",
  color: color,
}));
export const StyledContentContainer = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  width: "100%",
  maxWidth: "177px",
  margin: "0 auto",
  display: "flex",
  flexDirection: "column",
  gap: "7px",
}));

export const StyledInputContainer = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  position: "relative",
  width: "100%",
  height: "22px",
  border: `1px solid ${theme.customColors.grey[300]}`,
  borderRadius: "2px",
  fontSize: "8px",
  overflow: "hidden",
}));
export const StyledInput = styled("input", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  width: "100%",
  height: "100%",
  padding: "0 5.5px",
  border: "none",
  fontSize: "6px",
  backgroundColor: "white",
}));
export const StyledInputFakeButton = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  border: "none",
  background: theme.customColors.grey[900],
  color: "white",
  padding: "4px 5.5px",
  height: "100%",
  fontSize: "6px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
export const StyledFakeButton = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, bgColor }) => ({
  background: bgColor,
  color: "white",
  padding: "4px",
  height: "22px",
  fontSize: "8px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "6px",
  borderRadius: "2px",
}));
export const StyledContentText = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, color }) => ({
  color: color,
  textAlign: "center",
  fontSize: "6px",
}));
